<template>
  <div v-show="false"/>
</template>

<script>
import { mapGetters } from 'vuex';
import { preloadAssetsFromObject } from '@/utils/asset-util';

export default {
  computed: {
    ...mapGetters([
      'requiredAssets'
    ])
  },
  methods: {
    async load() {
      // alert('preloading assets');
      console.log('Received asset load request from API, preloading...');
      const requiredAssets = this.requiredAssets;
      console.log({ requiredAssets });
      await preloadAssetsFromObject(requiredAssets);
      console.log('Assets preloaded');
    }
  },
  watch: {
    requiredAssets: {
      handler() {
        console.log('preloading assets');
        this.load();
      },
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/game/pages/components/AssetPreloadWatcher.vue